import { FULL_PATHS } from '../constants';

/**
 * @param pathname - the current location.pathname
 * @returns true if the current path is one of the routes that displays the Manage Statements modal
 */
export const isOnManageStatementsRoute = (pathname: string): boolean =>
    pathname.includes(FULL_PATHS.MANAGE_STATEMENTS_CHARTS) ||
    pathname.includes(FULL_PATHS.MANAGE_STATEMENTS_TABLE);
